import { queryKeys } from "../queryKeys";
import { getEliteNetDeposits } from "../rest/elite";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetEliteNetDeposits = ({
  accountID,
  options,
}: {
  accountID: string;
  options?: QueryOptions<string>;
}) => {
  const { data } = useRequest(
    queryKeys.elite.netDeposits(accountID),
    () => getEliteNetDeposits(accountID),
    {
      ...options,
    },
  );

  return { netDeposit: data };
};

export default useGetEliteNetDeposits;
